import React, { useState, useEffect } from "react";
import "primeflex/primeflex.css";
import { InputSwitch } from "primereact/inputswitch";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
const Sections = (props) => {
  const [fields, setFields] = useState([]);
  useEffect(() => {
    props?.fields &&
      setFields(
        props?.fields.map((field) => ({
          ...field,
          enabled: true,
          placeholder: field.display_name,
        }))
      );
  }, []);

  const handlePlaceholderChange = (index, value) => {
    const updatedFields = [...props.fields];
    updatedFields[index].display_name = value;
    // Assuming there's a way to update fields in props
    setFields(updatedFields);
  };

  return (
    <div>
      {props?.fields.map((field, index) => (
        <div className="new-field" key={index}>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label htmlFor={field.value} className="p-label">
                {field?.ESG_section_name}:
              </label>
            </div>
            <div className='col pr-0'>
              <InputTextElementElement
                value={field?.display_name}
                onChange={(e) => handlePlaceholderChange(index, e.target.value)}
                placeholder={field?.display_name}
                className='w-full'
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Sections;
